import { Carousel2 } from '@intigral/ui/components/Carousel2';
import { useSelector } from 'react-redux';
import f from '../../../helpers/formatter';
import user from '../../../helpers/user';
import { __ } from '../../../translations';
import { getCountryPPVEvents } from '../../../utils/user';
import usePPVInfo from '../../../hooks/usePPVInfo';
import { useConfigurationSections } from '../../../hooks/useConfiguration';
import { usePPVEvents } from '../../../hooks/usePPVEvents';
import { SectionHeaderWithPagination } from '@intigral/ui/components/SectionHeaderWithPagination';
import { IStore } from '../../../interfaces/StoreTypes';
import useLanguage from '../../../hooks/useLanguage';
import { useConfiguration } from '../../../hooks/useConfiguration';
import { useCountryCode } from '../../../hooks/useConfiguration';
import { PPVItem } from './elements';
import { transformContentToCarouselItems } from '../utils/PPVUtils';
import { PPVCarouselProps } from '../types/iPPVCarousel';

const PPVCarousel: React.FC<PPVCarouselProps> = ({ content, carousel, meta }) => {
    // Hooks and State
    const language = useLanguage();
    const { operators } = useConfigurationSections();
    const { data: ppvEventConfig } = usePPVEvents();
    const countryCode = useCountryCode();
    const ppvEvents = getCountryPPVEvents(ppvEventConfig, operators, countryCode);
    const { userChannels } = useSelector((state: IStore) => state.liveTv);
    const { ppvSubscribedList } = usePPVInfo();
    const { operator } = user.getUserInfo() || {};
    const { data: config } = useConfiguration();

    const carouselContent = transformContentToCarouselItems(content, language, operator, ppvEvents, ppvSubscribedList);
    if (!carouselContent?.length) return null;

    return (
        <div
            className="container full-width"
            style={{ overflowX: 'hidden' }}
            id={carousel?.id}
            data-test-id={carousel?.id}
        >
            <SectionHeaderWithPagination title={f.getComponentTitle(meta)} className="paging" />
            <Carousel2
                swiperSettings={{
                    autoplay: false,
                    slidesPerView: 1.5,
                    slidesPerGroup: '1',
                    breakpoints: {
                        '560': {
                            slidesPerView: 3,
                        },
                        '768': {
                            slidesPerView: 4,
                        },
                        '1212': {
                            slidesPerView: 5,
                        },
                        '1500': {
                            slidesPerView: 6,
                        },
                    },
                    loop: false,
                    pagination: {
                        clickable: true,
                        el: '.paging',
                    },
                }}
                dir={language === 'ar' ? 'rtl' : 'ltr'}
            >
                {carouselContent.map((item, index) => {
                    return (
                        <PPVItem
                            key={`ppv-item-${index}`}
                            index={index}
                            item={item}
                            ppvEvents={ppvEvents}
                            userChannels={userChannels}
                            config={config}
                        />
                    );
                })}
            </Carousel2>
        </div>
    );
};

export default PPVCarousel;
